import api from '@/service/api';
import variables from "@/service/variables";
export default class CommonService {
     
    GetHeaderTitle() {
        return variables.HOME_URL 
    } 
    GetBusinessType() {
        return api.get(variables.API_URL + '/api/Common/BusinessType')
    } 
    GetMaterialGroup() {
        return api.get(variables.API_URL + '/api/Common/GetMaterialGroup')
    } 

    

    GetFestival() {
        return api.get(variables.API_URL + '/api/Common/GetFestival')
    } 
    GetSystems() {
        return api.get(variables.API_URL +'/api/Common/GetSystems')
    }
    GetSystemsByContact() {
        return api.get(variables.API_URL +'/api/Common/GetSystemsByContact')
    }
    


    GetSystemData() {
        return api.get(variables.API_URL +'/api/Common/GetSystemData')
    }
    GetSystemAvaliable() {
        return api.get(variables.API_URL +'/api/Common/GetSystemAvaliable')
    }
    

    GetApply(id) {
        return api.get(variables.API_URL +'/api/Common/GetApply/' + id)
    }
    GetApply4Vendor(id) {
        return api.get(variables.API_URL +'/api/Common/GetApply4Vendor/' + id)
    }
    

    CheckEmailExist(email) {
        return api.get(variables.API_URL +'/api/Common/CheckEmailExist/' + email)
    }
   
    SearchSupervisorAndUserList(Supervisor, SearchAccount, VendorCode,  MFGCode,  SearchTerm,  System, IsSingle){
        return api.get(variables.API_URL +'/api/Common/SearchSupervisorAndUserList/'+Supervisor+'/'+SearchAccount+'/'+VendorCode+'/'+MFGCode+'/'+SearchTerm+'/'+System+'/'+IsSingle)
    }
     SearchAuthoritySupervisorAndUserList(Supervisor, SearchAccount, VendorCode,  MFGCode,  SearchTerm,  System, IsSingle){
        return api.get(variables.API_URL +'/api/Common/SearchAuthoritySupervisorAndUserList/'+Supervisor+'/'+SearchAccount+'/'+VendorCode+'/'+MFGCode+'/'+SearchTerm+'/'+System+'/'+IsSingle)
    }
 
    UpadteUserLocales(Locales) {
        return api.post(variables.API_URL +'/api/Common/UpadteUserLocales/' + Locales)
    }

    Agree() {
        return api.post(variables.API_URL +'/api/Common/Agree')
    }
    DisAgree() {
        return api.post(variables.API_URL +'/api/Common/DisAgree')
    }

}